export default "__VITE_ASSET__BCJgu0Uu__"